// extracted by mini-css-extract-plugin
export var pillWrapper = "_mo-0";
export var showOverflow = "_mo-1";